import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router, NavigationExtras} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import {Location} from '@angular/common';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {Title} from "@angular/platform-browser";
import { ManagementServiceService } from 'src/app/management-service.service';
import { B2BService } from 'src/app/b2-b.service';
import { MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-b2b',
  templateUrl: './b2b.component.html',
  styleUrls: ['./b2b.component.css']
})
export class B2bComponent implements OnInit {

  getLanguage(): string {
    try {
      return localStorage?.getItem('language') ?? "";
    } catch (e) {
      console.warn("Could not access localStorage:", e);
      return "";
    }
  }

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

  constructor(private titleService:Title, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _snackBar: MatSnackBar, private location: Location) {
    
    this.titleService.setTitle("B2B FoxCloud");
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');
  
    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
  
      // Debounce search.
      this.partnerSearchTermUpdate.pipe(
        debounceTime(350),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.Filter.SearchTerm = value;
            this.GetPartnersFiltered();
          }
        });

          // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length > 2){
          this.SplitGetIndustryProductsSearchQuery(value);
        }
      });

           // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(350),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFilteredWithSuggestion(value);
        }
      });

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
   }

  brandSearch:string;
  brandSearchTermUpdate = new Subject<string>();
  partnerSearchTermUpdate = new Subject<string>();
  public BackendServiceUrl = this.service.APIUrl;
  B2BAgent:any;
  Cart: {[k: string]: any} = {};;

  private hydrateCartFromStorage(): void {
    try {
      const stored = localStorage.getItem('Cart');
      if (stored) {
        const parsed = JSON.parse(stored);
        // ensure expected shape
        this.Cart = parsed && Array.isArray(parsed.Items) ? parsed : { Items: [] };
      } else {
        this.Cart = { Items: [] };
      }
    } catch {
      this.Cart = { Items: [] };
    }
  }

  B2BPartner:any;
  OriginalB2BPartner:any;
  PartnerUserID:string;
  IsForcedB2BPartner:boolean;
  B2BPartnerName:string;

  mainLoading:boolean;
  
  CartItem:any;
  CartMasterData:any;
  IsAdmin:boolean = false;
  Partners:any[];
  Filter: {[k: string]: any} = {};
  BrandFilter: {[k: string]: any} = {};
  Brands:any[];
  ShowAdminInformation:boolean = false;

  ngOnInit(): void {

    this.InitializeFilter();
    this.InitializeBrandFilter();
    this.showContent = true;
    this.TestEnviorment();
    this.TestNetConnection();
    this.SetDefaultLanguage();
    this.User = JSON.parse(localStorage.getItem("User"));
    this.GetB2BRelevantAgents();

    if(this.User?.Rights?.MainRole?.ID == 3){
      this.ShowAdminInformation = true;
    }

    this.IsForcedB2BPartner = JSON.parse(localStorage.getItem("IsForcedB2BPartner"));
    this.OriginalB2BPartner = JSON.parse(localStorage.getItem("OriginalB2BPartner"));
 
    if(this.User == null){
     this.RedirectToURLWithUrlChange('login');
    }
    else{

      this.GetB2BMasterData();
    
     if(this.User.LastLogin == null || this.User.LastLogin?.length == 0){
        this.LogOff();
     }

     this.CheckUserAdminLevel();
     this.User.Rights.AssignedCompanies.forEach(element => {
       if(element.IsSelected == true){
         this.Company = element;
       }
 
       this.SearchResultTypes = this.User.Settings.SearchResultTypes.filter(x => x.IsSelected == true && x.ID != 0);
       this.SearchInProducts = this.User.Settings.SearchInProducts;
     });

     if(this.Company == null){
      this.RedirectToURLWithUrlChange('login/success/company/select');
     }

        //get master data
   var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetMasterData(request).subscribe(response => {

   if(response["Status"] != 1){
   
   }
   else if(response["Status"] == 1){
    this.masterData = response;
    var Apps = response["Applications"];
    this.Applications = [];

    Apps.forEach(app => {
      for(var i=0;i<this.User.AppAccess.length; i++){
        if(this.User.AppAccess[i].Application.ID == app.ID){
          if(this.User.AppAccess[i].Application.Access == true){
            this.Applications.push(app);
          }
        }
      }
    });    
    
    this.OrderTypes = response["OrderTypes"];
    this.RightTypes = response["RightTypes"];
    this.OfferPriorityStatuses = response["OfferPriorityStatuses"];
    this.GetSetApplicationByUrl();
   }

   this.loading = false;
   this.GetMainCurrency();
   
 },
 (err) => {
  this.translate.get("ServerConnectionError").subscribe((resource: string) => {
    this.loading = false;
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
    this.CurrentApp = this.User?.Rights?.Application;
    this.showContent = false;
  });
 });
 
    this.CompanyNotificationOnlyUnSeen = null;

    this.GetUserAssignedCompanies();
    this.SendEmailWithAttachment = true;
    }

    this.GetShippingMasterData();
  }

  GetB2BMasterData(){
    var request = {
      User:this.User,
      Language:this.getLanguage(),
    };
  
    this.loading = true;
  
    this.B2BService.GetB2BMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CartMasterData = JSON.parse(JSON.stringify(response));
      }
   
      this.loading = false;
    });
  }

  GetUserDisabledFlag(){

    var request = {
      User:this.User,
      Language:this.getLanguage(),
    };

    this.loading = true;

    this.service.GetUserDisabledFlag(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.LogOff();
      }
      else if(response["Status"] == 1){
        
      }

      this.loading = false;
    });
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.ProductBoxStatus = {};
    this.Filter.ProductBoxStatus = null;

    this.Filter.ProductConditionStatus = {};
    this.Filter.ProductConditionStatus = null;

    this.Filter.ProductManufacturingStatus = {};
    this.Filter.ProductManufacturingStatus = null;

    this.Filter.ProductVersionStatus = {};
    this.Filter.ProductVersionStatus = null;

    this.Filter.Creator = {};
    this.Filter.Creator = null;

    this.Filter.Updater = {};
    this.Filter.Updater = null;
  }

  GetB2BUserConnectedPartner(user:any){

    var request = {
      User:user,
      Language:this.getLanguage(),
    };

    this.PartnerUserID = JSON.parse(localStorage.getItem("PartnerUserID"));

    if(this.PartnerUserID){
      if(this.PartnerUserID.length > 0){
        request.User.Id = this.PartnerUserID;
      }
    }
  
    this.B2BService.GetB2BUserConnectedPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.B2BPartner = response["Partner"];
        this.B2BPartnerName = this.B2BPartner?.Name;
        this.GetB2BUserConnectedAgent();
      }
    });
  }

  GetCart(){
    this.Cart = JSON.parse(localStorage.getItem("Cart"));
  }

  UpdateCart(){
    localStorage.setItem('Cart', JSON.stringify(this.Cart));
  }

  CheckUserAdminLevel(){
    if(this.User?.Rights?.Application?.ID == 3){
      if(this.User?.Rights?.MainRole?.ID == 3){
        this.IsAdmin = true;
      }
    }
  }

  ShowLogisticsMenu:boolean;
  ShowOrdersMenu:boolean;
  ShowQuotationsMenu:boolean;
  ShowTasksMenu:boolean;
  ShowProductsMenu:boolean;
  ShowSettingsMenu:boolean;

  OpenCloseMenu(menu:string){
    if(menu == "Logistics"){
      this.ShowLogisticsMenu = !this.ShowLogisticsMenu;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
    }
    else if(menu == "Orders"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = !this.ShowOrdersMenu;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
    }
    else if(menu == "Quotations"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = !this.ShowQuotationsMenu;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
    }
    else if(menu == "Tasks"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = !this.ShowTasksMenu;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
    }
    else if(menu == "Products"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = !this.ShowProductsMenu;
      this.ShowSettingsMenu = false;
    }
    else if(menu == "Settings"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = !this.ShowSettingsMenu;
    }
  }

SendEmailWithAttachment:boolean;
CompanyNotificationOnlyUnSeen:boolean;
UnseenCompanyNotificationPager:boolean;
CompanyNotifications:any[];
CompanyNotificationPager:any;
masterData:any;
searchTermUpdate = new Subject<string>();
ShowAppsSelect:boolean = false;
Applications:any[];
CurrentApp:any;
AuxCurrentApp:any;
LocalEnviormentWithLiveAPIWarning:boolean = false;
User:any;
Company:any;
SearchResultTypes:any[];
SearchInProducts:boolean;
loading:boolean;
initialLoad:boolean;
mainCurrency:any;
isSearchActive:boolean;
showContent:boolean;
showLoggOffContainer:boolean;
OrderTypes:any[];
RightTypes:any[];

InvoiceMenu:boolean = false;
OrdersMenu:boolean = false;
SavedOffersPOsMenu:boolean = false;
PriceListMenu:boolean = false;
MyProfileMenu:boolean = false;
CartMenu:boolean = false;

 // Only Integer Numbers
 OnlyNumbers($event) {
  var charCode = $event.key;
  // Only Numbers 0-9
  if (((charCode < 48 || charCode > 57) && $event.key != '.')) {
    $event.preventDefault();
    return false;
  } else {
    return true;
  }
}

GetUserAssignedCompanies(){

  var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetUserAssignedCompanies(request).subscribe(response => {

   if(response["Status"] != 1){
   
   }
   else if(response["Status"] == 1){
     this.User.Rights.AssignedCompanies = response["AssignedCompanies"];
   }

   this.loading = false;
   
 });
}

GetMainCurrency(){
  this.mainCurrency = this.Company?.Addresses[0]?.Country?.Currency;
}

openSnackBar(message: string, action: string, designClass: string, duration:number = 5000) {
  this._snackBar.open(message, action, {
    duration: duration,
    panelClass: [designClass]
  });
}

CloseDashMenu(){
  this.ShowMainMenu = false;
  this.ShowCart = false;
}

SetDefaultLanguage(){

  if(this.getLanguage() == ''){
    this.setLanguage("en");
  }
}

TestEnviorment(){

  var fullpath = this.router['location']._platformLocation.location.origin;

  if((!this.service.APIUrl.includes("localhost") || !this.managementService.APIUrl.includes("localhost")) && fullpath.includes("localhost")){
    this.LocalEnviormentWithLiveAPIWarning = true;
  }

 // Retrieve the full URL from the router's location
 const pathName = this.router['location']._platformLocation.location.pathname;

  if(pathName.toLowerCase() == "/b2b/search" || pathName.toLowerCase() == "/b2b/pricelist"){
    this.PriceListMenu = true;
  }
  else if(pathName.toLowerCase() == "/b2b/my/invoices"){
    this.InvoiceMenu = true;
  }
  else if(pathName.toLowerCase() == "/b2b/my/requests"){
    this.SavedOffersPOsMenu = true;
  }
  else if(pathName.toLowerCase() == "/b2b/my/orders"){
    this.OrdersMenu = true;
  }
  else if(pathName.toLowerCase() == "/b2b/profile"){
    this.MyProfileMenu = true;
  }
  else if(pathName.toLowerCase() == "/b2b/store/cart"){
    this.CartMenu = true;
  }
}

TestNetConnection(){

  if(navigator.onLine == false){
    this.translate.get("OfflineConnection").subscribe((resource: string) => {
      this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
    });
   }
}

getUrlWithoutParams(){
  let urlTree = this.router.parseUrl(this.router.url);
  urlTree.queryParams = {}; 
  return urlTree.toString();
}

GetSetApplicationByUrl(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams()
  };

  this.loading = true;

 this.service.GetSetApplicationByUrl(request).subscribe(response => {

   if(response["Status"] != 1){
    this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    var currentURL = response["URL"];
    this.CurrentApp = currentURL.Application;
    
    this.User.Rights.Application = currentURL.Application;
    this.User.AppAccess.forEach(AppAccess => {
      if(AppAccess.Application.ID == this.CurrentApp.ID){
        AppAccess.IsSelected = true;
      }
      else{
        AppAccess.IsSelected = false;
      }
    });

    localStorage.setItem('User', JSON.stringify(this.User));

    if(this.User.Rights.Application.RequiresToken == true){
      let MFATokenCookie:any = this.cookieService.get('MFAuthToken');

      if(!MFATokenCookie){
        this.RedirectToURLWithUrlChange('login/MFA');
      }
    }

    this.GetB2BUserConnectedPartner(this.User);
   }
   this.loading = false;
 },
 (err) => {
  this.translate.get("AppIdentificationError").subscribe((resource: string) => {
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
  });
 });

}

RedirectToURLWithUrlChange(url:string){
  this.router.navigate([url], { replaceUrl: true }); 
}

RedirectToURLWithUrlForcedChange(url:string){

  this.loading = true;

  const navigationExtras: NavigationExtras = {
    skipLocationChange: false,
    replaceUrl: true,
  };
  this.router.navigate([url], navigationExtras);
  setTimeout(() => window.location.reload(), 100);
}

OpenAppsSelect(){
  this.AuxCurrentApp = JSON.parse(JSON.stringify(this.CurrentApp));

  if(this.Applications?.length > 1){
    this.ShowAppsSelect = true;
  }
}

AuxCompany:any;
ShowCompanySelect:boolean;

OpenCompanySelect(){
  this.AuxCompany = JSON.parse(JSON.stringify(this.Company));
  this.ShowCompanySelect = true;
}

SwitchApplication(){
  this.CurrentApp = JSON.parse(JSON.stringify(this.AuxCurrentApp));
  this.UpdateUserLastSelectedApplication(this.CurrentApp);
}

UpdateUserLastSelectedApplication(App:any){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id,
    ApplicationID:App.ID
  };

  this.loading = true;

  this.service.UpdateUserLastSelectedApplication(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.User.Rights.Application = JSON.parse(JSON.stringify(App));
      this.User.AppAccess.forEach(AppAccess => {
        if(AppAccess.Application.ID == App.ID){
          AppAccess.IsSelected = true;
        }
        else{
          AppAccess.IsSelected = false;
        }
      });

      this.User.Id = JSON.parse(JSON.stringify(this.User.Settings.UserID));
      localStorage.setItem('User', JSON.stringify(this.User));
      this.B2BPartner = JSON.parse(JSON.stringify(this.OriginalB2BPartner));
      localStorage.removeItem('PartnerUserID');
      localStorage.removeItem('OriginalB2BPartner');
      localStorage.removeItem('IsForcedB2BPartner');

      this.RedirectToURLWithUrlChangeNewTab(App.MainURL);
      this.ShowAppsSelect = false;
    }
 
    this.loading = false;
  });
}

RedirectToURLWithUrlChangeNewTab(url:string){
  window.open(url, '_blank');
}

compareMultipleFn(o1: any, o2: any): boolean {
  
  // if possible compare by object's name property - and not by reference.
  return o1 && o2 ? o1.ID === o2.ID : o2 === o2;
}

compareFn(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

 compareSelection(c1: any): boolean {
  return c1 && c1.IsSelected === true;
}

OpenLogOff(){
  this.showLoggOffContainer = true;
}

LogOff(){
  this.loading = true;
  localStorage.removeItem("User");
  this.cookieService.delete("MFAuthToken", "/");
  window.location.reload();
}

UpdateUserLastUsedCompany(CompanyID:number){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    LastUsedCompanyID:CompanyID,
    UserID:this.User.Id
  };

  this.loading = true;

  this.service.UpdateUserLastUsedCompany(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.RedirectToURLWithUrlChange(this.CurrentApp.MainURL);
    }
   
    this.loading = false;
  });
}

ChangeMainCompany(company:any){

  this.User.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;

    if(element.ID == company.ID){
      element.IsSelected = true;
    }

    localStorage.setItem('User', JSON.stringify(this.User));
    this.Company = company;
    this.UpdateUserLastUsedCompany(company.ID);
  });

  this.ShowCompanySelect = false;
}

GetUserManagementInfo(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams()
  };

  this.loading = true;

  this.service.GetUserManagementInfo(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      this.RedirectToURLWithUrlChange("management/personal/settings");
    }
    else if(response["Status"] == 1){
      this.User.UserManagementInfo = response["UserManagementInfo"];
    }
   
    this.loading = false;
  });
}

newGuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxxxxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

ShowMainMenu:boolean = false;

OpenCloseMainMenu(){
  this.ShowMainMenu = !this.ShowMainMenu;
}

ChangeLanguage(lang:any){
  this.User.Settings.Language = lang;
  this.AddUpdateUserSettings();
}

AddUpdateUserSettings(){

  var request = {
    User:this.User,
    Settings:this.User.Settings,
    Language:this.getLanguage()
  };

  this.loading = true;

  this.service.AddUpdateUserSettings(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      localStorage.setItem('User', JSON.stringify(this.User));
      this.setLanguage(this.User.Settings.Language.Name.toLowerCase());
      this.translate.use(this.User.Settings.Language.Name.toLowerCase());

      this.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
 
    this.loading = false;
  });
}

RelevantAgents:any[];

GetB2BRelevantAgents(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
  };

  this.mainLoading = true;

  this.B2BService.GetB2BRelevantAgents(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.RelevantAgents = response["Agents"];
    }
 
    this.mainLoading = false;
  });
}


GetB2BUserConnectedAgent(){

  var request = {
    User:this.User,
    Settings:this.User.Settings,
    Language:this.getLanguage(),
  };

  this.PartnerUserID = JSON.parse(localStorage.getItem("PartnerUserID"));

  if(this.PartnerUserID){
    if(this.PartnerUserID.length > 0){
      request.User.Id = this.PartnerUserID;
    }
  }

  this.mainLoading = true;

  this.B2BService.GetB2BUserConnectedAgent(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.B2BAgent = response["Agent"];
      this.ReInitializaAllCartItems();
    }
 
    this.mainLoading = false;
  });
}

ReInitializaAllCartItems(){
  if(this.Cart != null && this.Cart.Items != null && this.Cart.Items?.length > 0){
    
  }
}

ShowCart:boolean;
ShowDeleteBoxQuestion:boolean;

OpenCart(){
  this.ShowCart = true;
}

AddNewCartItem(searchResult:any){
  var item = {
    Product:{
      ID:searchResult.ProductID
    }
  };

  this.InitializeCartItem(item);
}

InitializeCartItem(p:any){

  if(p.Product.ID == 0 && p.ProductID != null){
    p.Product.ID = p.ProductID;
  }

  p.Quantity = this.GetProductCartQuantity(p.Product.ID);

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    CartItem:p,
    Partner:this.B2BPartner,
    CartItems:this.Cart?.Items
  };

  this.loading = true;

  this.B2BService.InitializeCartItem(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Cart.Items = JSON.parse(JSON.stringify(response["CartItems"]));
    }
 
    this.loading = false;
  });
}

GetProductCartQuantity(productID:number): string{

  var Quantity = 0;

  if(this.Cart != null){
   for(var i=0;i<this.Cart.Items?.length; i++){
     if(this.Cart.Items[i].Product.ID == productID){
       Quantity = Quantity + parseInt(this.Cart.Items[i].Quantity);
     }
   }
  }
  else{
    Quantity = 1;
  }

  return Quantity.toString();
}

SelectCartItem(item:any){
  this.CartItem = item;
}

DeleteCartItem(){
  if(this.CartItem){
    for(var i=0;i<this.Cart.Items.length;i++){
      if(this.Cart.Items[i].UIID == this.CartItem.UIID){
        this.Cart.Items = this.Cart.Items.filter(x => x.UIID != this.CartItem.UIID);
      }
    }
  }

  this.InitializeCart();
}

InitializeCart(){
    
  // var request = {
  //   User:this.User,
  //   Language:this.getLanguage(),
  //   Cart:this.Cart,
  //   Client:this.B2BPartner,
  //   B2BMasterData:this.CartMasterData
  // };

  // this.loading = true;

  // this.B2BService.InitializeCart(request).subscribe(response => {

  //   if(response["Status"] != 1){
  //     this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  //   }
  //   else if(response["Status"] == 1){
  //     this.Cart = response["Cart"];
  //     this.CartMasterData = response["B2BMasterData"];
  //     this.UpdateCart();
  //   }

  //   this.loading = false;
  //  });
}

ShippingCompanies:any[];

GetShippingMasterData(){
  var request = {
   User:this.User,
   Language:this.getLanguage()
 };

this.loading = true;

this.managementService.GetShippingMasterData(request).subscribe(response => {

  if(response["Status"] != 1){
   this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
   this.ShippingCompanies = response["ShippingCompanies"];
  }

  this.loading = false;
 });
 }

 InitializePartners(){
  if(this.Partners == null || this.Partners.length == 0){
    this.Filter.Pager.PageIndex = 1;
    this.Filter.SearchTerm = "";
    this.GetPartnersFiltered();
  }
}

GetPartnersFiltered(){
  var request = {
    SearchTerm:this.Filter.SearchTerm,
    CountryID:this.Filter.Country?.ID,
    PageIndex:this.Filter.Pager.PageIndex,
    PageSize:this.Filter.Pager?.PageSize,
    User:this.User,
    Language:this.getLanguage(),
    CompanyID:this.Filter.Company?.ID,
    CheckAdmin:true,
  };

  this.loading = true;

  this.service.GetPartnersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Partners = response["Partners"];
     this.Filter.Pager.TotalCount = response["Count"];
    }
 
    this.loading = false;
  });
}

ClearPartner(){
  this.B2BPartnerName = "";
}

SelectB2BPartnerForAdmin(p:any){
  this.ProofUserB2BData(this.User.Id, p);
}

public toggleB2BPartnerForAdminSelection(event: any) {
  if(event.checked == false){
    this.CancelB2BPartnerForAdminSelection();
  }
}

CancelB2BPartnerForAdminSelection(){
  this.B2BPartner = JSON.parse(JSON.stringify(this.OriginalB2BPartner));
  localStorage.removeItem('PartnerUserID');
  localStorage.removeItem('OriginalB2BPartner');
  localStorage.removeItem('IsForcedB2BPartner');
  window.location.reload();
}

ProofUserB2BData(UserID:string, p:any){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    B2BPartner:p,
  };

  this.loading = true;
  var auxB2BPartner = JSON.parse(JSON.stringify(this.B2BPartner));

  this.B2BService.ProofUserB2BData(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      this.B2BPartnerName = JSON.parse(JSON.stringify(auxB2BPartner.Name));
    }
    else if(response["Status"] == 1){
      localStorage.setItem('OriginalB2BPartner', JSON.stringify(this.B2BPartner));
      this.PartnerUserID = response["PartnerUserID"];
      localStorage.setItem('PartnerUserID', JSON.stringify(this.PartnerUserID));
      this.IsForcedB2BPartner = true;
      localStorage.setItem('IsForcedB2BPartner', JSON.stringify(this.IsForcedB2BPartner));
      this.B2BPartnerName = JSON.parse(JSON.stringify(p.Name));
      window.location.reload();
    }
 
    this.loading = false;
  });
}

CartItemRows: {[k: string]: any} = [];

ExportB2BGrid(){
    
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    CartItems:this.CartItemRows,
  };

  this.loading = true;

  this.B2BService.ExportB2BGrid(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }
   });

   this.loading = false;
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

OfferPriorityStatuses:any[];
OfferPriorityStatus:any;
loadingProducts:boolean;

PopulateCartItems(rows = 50){
    
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Rows:rows
  };

  this.loadingProducts = true;

  this.B2BService.PopulateCartItems(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var CI = JSON.parse(JSON.stringify(response["CartItems"]));
      this.CartItemRows = this.CartItemRows.concat(CI);
    }

    this.loadingProducts = false;
   });
}

CurrentCartItemRow:any;
SearchedProducts:any[];
itemOverlay:boolean = false;

CloseItemOverlay(){
  this.itemOverlay = false;

  this.CartItemRows.forEach(cell => {
    cell.ShowBrandSearchResults = false;
    cell.ShowSearchResults = false;
  });
}

InitializeSearchProduct(item:any){

  this.CurrentCartItemRow = item;
  this.SelectItem(item);

  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.SearchIndustryProducts();
  }

  if(item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true){
    item.ShowBrandSearchResults = true;
    this.GetBrandsFilteredWithSuggestion("", 1, item.UIProductValue);
    this.itemOverlay = true;
  }
}

SelectItem(i:any){
  this.CartItemRows.forEach(cell => {
    if(cell.UIID == i.UIID){
      cell.ShowSearchResults = !cell.ShowSearchResults;

      if(cell.ShowSearchResults == true && cell.WasSearchedFor == true){
        this.itemOverlay = true;
      }
    }
    else{
      cell.ShowSearchResults = false;
    }
  });
}

SearchIndustryProducts(){
    
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.SearchIndustryProducts(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["SearchResults"];
    }

    this.loadingProducts = false;
   });
}

SelectGridSearchResult(s:any, item:any){

  item.SearchResults.forEach(element => {
    element.IsSelected = false;
  });

  // Find the index of the matching search result
const index = item.SearchResults.findIndex(searchResult => searchResult.UIID === s.UIID);

// If a matching search result is found
if (index !== -1) {
    // Set ShowSearchResults to true
    item.SearchResults[index].IsSelected = true;

    // Move the matching search result to the beginning of the array
    // const selectedSearchResult = item.SearchResults.splice(index, 1)[0];
    // item.SearchResults.unshift(selectedSearchResult);
}

  item.ShowSearchResults = false;
  this.GetGridCellItemData(JSON.parse(JSON.stringify(item)));
}

async GetGridCellItemData(c: any, Priority: any = null) {
  var request = {
    User: this.User,
    Language: this.getLanguage(),
    newItem: c,
    Partner: this.B2BPartner,
    Agent: this.B2BAgent,
    Priority: Priority,
  };

  try {
    // Convert observable to a promise and await it
    const response = await this.B2BService.GetGridCellItemData(request).toPromise();

    if (response["Status"] != 1) {
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      var Item = response["Item"];

      this.CartItemRows.forEach((cell, index) => {
        if (cell.UIID == c.UIID) {
          this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
          this.Cart.Items = JSON.parse(JSON.stringify(this.CartItemRows));
          this.InitializeCart();
        }
      });
    }
  } catch (error) {
    console.error("Error in GetGridCellItemData:", error);
  }
}

async SplitGetIndustryProductsSearchQuery(searchQuery: string) {
  var request = {
    User: this.User,
    Language: this.getLanguage(),
    SearchQuery: searchQuery,
    UIID: this.CurrentCartItemRow.UIID,
    CartItems: this.CartItemRows,
    Partner: this.B2BPartner
  };

  this.CartItemRows.forEach(cell => {
    if (cell.UIID == this.CurrentCartItemRow.UIID) {
      cell.LoadingCell = true;
      // cell.Quantity = this.sanitizeQuantityInput(cell.Quantity);
    }
  });

  this.B2BService.SplitGetIndustryProductsSearchQuery(request).subscribe(async response => {
    if (response["Status"] !== 1) {
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] === 1) {
      this.CartItemRows = [];
      this.CartItemRows = JSON.parse(JSON.stringify(response["CartItems"]));

      // Convert forEach to map + Promise.all to await all async calls
      await Promise.all(
        this.CartItemRows
          .filter(x => !x.WasSearchedFor && x.UIProductValue?.length > 0)
          .map(async (cell) => {
            await this.SearchIndustryProductsFromGridCell(cell); // Now waits correctly!
          })
      );

      // Now that all async calls are finished, call the final function
      this.CombineStocks();
    }

    this.searchTermUpdate.next(null);
  });
}

async CombineStocks(){
  for (let i = 0; i < this.CartItemRows.length; i++) {
    let cartItem = this.CartItemRows[i];

    // Ensure the item has a SelectedOffer with an ID
    if (!cartItem.SelectedOffer || !cartItem.SelectedOffer.ID) {
      continue;
    }

    let offerID = cartItem.SelectedOffer.ID;
    let duplicateFound = false; // ✅ Track if a duplicate is found

    // Loop through the rest of the list to find duplicates
    for (let j = i + 1; j < this.CartItemRows.length; j++) {
      if(this.CartItemRows[j]?.SelectedOffer?.IsStockOffer == true){
        let anotherCartItem = this.CartItemRows[j];

        // Check if it's a duplicate (same SelectedOffer.ID)
        if (anotherCartItem.SelectedOffer && anotherCartItem.SelectedOffer.ID === offerID && anotherCartItem.SelectedOffer.IsStockOffer == true) {
          console.log(`Duplicate found: Merging item with SelectedOffer.ID ${offerID}`);
  
          // ✅ Add the quantity from the duplicate item
          cartItem.Quantity = Number(cartItem.Quantity) + Number(anotherCartItem.Quantity);
  
          // ✅ Remove the duplicate item from the list
          this.CartItemRows.splice(j, 1);
          j--; // Adjust index after removal to prevent skipping items
  
          duplicateFound = true; // ✅ Mark that a duplicate was found
          break;
        }
      }
    }

    // ✅ Call ChangeGridCellItem ONLY IF a duplicate was found
    if (duplicateFound) {
      await this.ChangeGridCellItem(cartItem, false);
    }
  }
}

CheckExceedingStocks() {
  var request = {
    User: this.User,
    Language: this.getLanguage(),
    Cart: this.Cart,
  };

  this.loading = true;

  this.B2BService.CheckExceedingStocks(request).subscribe(async response => {
    if (response["Status"] !== 1) {
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] === 1) {
      this.Cart = JSON.parse(JSON.stringify(response["Cart"]));
    }

    this.loading = false;
  });
}

async SearchIndustryProductsFromGridCell(item: any) {
  var request = {
    User: this.User,
    Language: this.getLanguage(),
    UIID: item.UIID,
    CartItem: item,
  };

  this.CartItemRows.forEach(cell => {
    if (cell.UIID == item.UIID) {
      cell.LoadingCell = true;
      // cell.Quantity = this.sanitizeQuantityInput(cell.Quantity);
    }
  });

  try {
    // Convert observable to promise (for Angular 11 - RxJS 6)
    const response = await this.B2BService.SearchIndustryProductsFromGridCell(request).toPromise();

    if (response["Status"] != 1) {
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    } else if (response["Status"] == 1) {
      var Item = response["CartItem"];

      for (let index = 0; index < this.CartItemRows.length; index++) {
        let cell = this.CartItemRows[index];
        if (cell.UIID == item.UIID) {
          this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
          await this.GetGridCellItemData(JSON.parse(JSON.stringify(this.CartItemRows[index])));
        }
      }
    }

    this.CartItemRows.forEach(cell => {
      if (cell.UIID == item.UIID) {
        cell.LoadingCell = false;
      }
    });

    this.searchTermUpdate.next(null);
  } catch (error) {
    console.error("Error fetching industry products:", error);
  }
}

async ChangeGridCellItem(item:any, SplitQunatityIfStockIsNotEnough:boolean = true){
    
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    item:item,
    SplitQunatityIfStockIsNotEnough:SplitQunatityIfStockIsNotEnough,
    Partner:this.B2BPartner
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = true;
        // cell.Quantity = this.sanitizeQuantityInput(cell.Quantity);
      }
  });

  this.B2BService.ChangeGridCellItem(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["item"];
      var SplittedItem = response["SplittedItem"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));

            if(SplittedItem != null){
              this.CartItemRows[index + 1].LoadingCell = true;
            }
            else{
              this.CartItemRows[index + 1].LoadingCell = false;
            }
        }
      });

      if(SplittedItem != null){

        var Priority = {
          ID:0,
        };

        var request = {
          User:this.User,
          Language:this.getLanguage(),
          newItem:SplittedItem,
          Partner:this.B2BPartner,
          Agent:this.B2BAgent,
          Priority:Priority,
        };
      
        this.B2BService.GetGridCellItemData(request).subscribe(response => {
      
          if(response["Status"] != 1){
            this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
          }
          else if(response["Status"] == 1){
      
            var FinalSplittedItem = response["Item"];

            // Find the index of the cell with matching UIID
            const index = this.CartItemRows.findIndex(cell => cell.UIID === item.UIID);

            // If the index is found, insert a blank element to the right
            if (index !== -1) {
              this.CartItemRows.splice(index + 1, 0, null as any); // Replace `null` with your desired blank value
              FinalSplittedItem.LoadingCell = false;
              FinalSplittedItem.WasSearchedFor = true;
              this.CartItemRows[index + 1] = JSON.parse(JSON.stringify(FinalSplittedItem));

              if(SplittedItem.Quantity != FinalSplittedItem.Quantity){
                this.CartItemRows[index + 1].Quantity = SplittedItem.Quantity;
                this.ChangeGridCellItem(this.CartItemRows[index + 1], false);
              }
            }
          }
         });
      }
    }

    this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = false;
      }
    });

    this.InitializeCart();
    this.searchTermUpdate.next(null);
   });
  //  this.CheckExceedingStocks();
}

  SelectedGrid:boolean = false;

  SelectAll(){
    this.CartItemRows.forEach(r => {
      r.IsSelected = this.SelectedGrid;
    });
  }

  RemoveItem(item:any){
    this.CartItemRows = this.CartItemRows.filter(x => x.UIID != item.UIID);
    this.Cart.Items = this.CartItemRows;
    this.InitializeCart();
  }

  ClearGridQuestion:boolean = false;

  AskClearGridQuestion(){
    this.ClearGridQuestion = true;
  }

  ClearGrid(){
    localStorage.removeItem("Cart");
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 50;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  BrandsLoading:boolean = false;

  GetBrandsFilteredWithSuggestion(searchTerm:string, page = 1, implicitProduct:string = null){
    
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.User,
        Language:this.getLanguage(),
        Filter:this.BrandFilter,
        Product:implicitProduct
      };

      this.BrandsLoading = true;

      this.managementService.GetBrandsFilteredWithSuggestion(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
        }

        this.BrandsLoading = false;
       });
  }

  SelectItemBrand(item:any, brand:any){
      item.ShowBrandSearchResults = false;
      item.UserSelectedBrand = JSON.parse(JSON.stringify(brand));

      this.CloseItemOverlay();

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(item));
        }
    });

    this.InitializeCart();
  }

  OfferRequest: {[k: string]: any} = {};

  AddNewOfferRequest(POButtonPressed:boolean = false, cart:any = null){
    if(this.loading != true){

     if(!cart){
      this.GetCart();
     }
     else{
      this.Cart = JSON.parse(JSON.stringify(cart));
     }
   
     this.OfferRequest.UserUploader = this.User;
     this.OfferRequest.AgentManager = this.B2BAgent;
     this.OfferRequest.Company = this.Company;
     this.OfferRequest.Cart = this.Cart;
     this.OfferRequest.Type = this.CartMasterData.OrderTypes[4];
     this.OfferRequest.PaymentType = this.Cart.PaymentType;
   
     var request = {
       User:this.User,
       Language:this.getLanguage(),
       OfferRequest:this.OfferRequest,
       POButtonPressed:POButtonPressed,
     };
   
     this.loading = true;
   
     this.B2BService.AddNewOfferRequest(request).subscribe(response => {
   
       if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         var OfferRequest = response["OfferRequest"];
         localStorage.removeItem("Cart");
         this.GoToRequestOfferConfirmation(OfferRequest.ID);
       }
   
       this.loading = false;
      });
    }
   }

   DownloadOfficialOfferPDF(){
   
     this.OfferRequest.UserUploader = this.User;
     this.OfferRequest.AgentManager = this.B2BAgent;
     this.OfferRequest.Company = this.Company;
     this.OfferRequest.Cart = this.Cart;
     this.OfferRequest.Type = this.CartMasterData.OrderTypes[4];
     this.OfferRequest.PaymentType = this.Cart.PaymentType;
   
     var request = {
       User:this.User,
       Language:this.getLanguage(),
       OfferRequest:this.OfferRequest,
     };
   
     this.loading = true;
   
     this.B2BService.DownloadOfficialOfferPDF(request).subscribe(response => {
   
       if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
          var Document = response["Document"];
          this.download(Document.Name, Document.PDFStream);
       }
   
       this.loading = false;
      });
   }

   GoToRequestOfferConfirmation(RequestOfferID:any){
    this.router.navigate(['B2B/store/cart/offer/reqest/confirmation'], { queryParams: { RequestOfferID: RequestOfferID } });
  }

  ShowItemStockOptions:boolean;
  CurrentGridItem:any;
  SideOffersLoading:boolean;

  hasSearchResults(): boolean {
    return this.CartItemRows.some(item => item?.ShowSearchResults && item?.SearchResults?.length > 0);
  }

  closeSearchResults() {
    this.CartItemRows.forEach(element => {
       element.ShowSearchResults = false;
    });
  }

  PrepareGridCellItemSideOffers(item:any){
    this.CurrentGridItem = JSON.parse(JSON.stringify(item));
   
      var request = {
        User:this.User,
        Language:this.getLanguage(),
        Filter:this.BrandFilter,
        CartItem:item,
        Partner:this.B2BPartner,
        Agent:this.B2BAgent
      };

      this.SideOffersLoading = true;

      this.B2BService.PrepareGridCellItemSideOffers(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.CurrentGridItem.Product.ListPriceOffers = JSON.parse(JSON.stringify(response["ListPriceOffers"]));
        }

        this.SideOffersLoading = false;
       });

    this.ShowItemStockOptions = true;
  }

  SelectOfferFromGrid(o:any, item:any){
    item.Product.ListPriceOffers.forEach(element => {
      if(element.ID == o.ID){
        element.IsSelected = true;
      }
    });

    item.SelectedOffer = JSON.parse(JSON.stringify(o));
    item.Price = JSON.parse(JSON.stringify(item.SelectedOffer.SellPrice));
    
    var request = {
      User:this.User,
      Language:this.getLanguage(),
      item:item,
    };
  
    this.CartItemRows.forEach(cell => {
        if(cell.UIID == item.UIID){
          cell.LoadingCell = true;
        }
    });

    this.SideOffersLoading = true;
  
    this.B2BService.ChangeGridCellItem(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
  
        var Item = response["item"];
  
        this.CartItemRows.forEach((cell, index) => {
          if(cell.UIID == item.UIID){
              this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
          }
        });
      }
  
      this.CartItemRows.forEach(cell => {
        if(cell.UIID == item.UIID){
          cell.LoadingCell = false;
        }
      });
  
      this.InitializeCart();
      this.searchTermUpdate.next(null);
      this.SideOffersLoading = false;
      this.ShowItemStockOptions = false;
     });
  }

  OpenSpecialOffers(){

  }

  sanitizeQuantityInput(input: string | null | undefined): number {
    if (!input) return 1;

  // Convert input to string to safely apply replace
  const strInput = String(input);

  // Remove non-numeric characters except 1-9
  const filteredInput = strInput.replace(/[^1-9]/g, '');

  // Convert to number
  const num = Number(filteredInput);

  // Ensure valid numeric input
  return isNaN(num) || num <= 0 ? 1 : num;
  }

  ShowSpecialOffersOptions:boolean;
  SpecialOffersList:any[];


}
